import { render, staticRenderFns } from "./TipsFetch.vue?vue&type=template&id=0c5a304c&scoped=true&"
import script from "./TipsFetch.vue?vue&type=script&lang=js&"
export * from "./TipsFetch.vue?vue&type=script&lang=js&"
import style0 from "./TipsFetch.vue?vue&type=style&index=0&id=0c5a304c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5a304c",
  null
  
)

component.options.__file = "TipsFetch.vue"
export default component.exports